import React from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import RoleBasedNavigation from '../../components/navigation/RoleBasedNavigation';
import RegistrationForm from './components/RegistrationForm';
import BenefitsSection from './components/BenefitsSection';
import TrustSignals from './components/TrustSignals';

const Registration = () => {
  const { user, userProfile, isAuthenticated } = useAuth();

  return (
    <>
      <Helmet>
        <title>Create Your BardPlay Account | Start Learning Shakespeare</title>
        <meta name="description" content="Join BardPlay and begin your Shakespeare mastery journey. Create your free account and access gamified learning, performance tools, and collaborative features." />
      </Helmet>
      
      <div className="min-h-screen flex flex-col animated-gradient-bg">
        <RoleBasedNavigation 
          user={{
            ...user,
            role: userProfile?.role,
            full_name: userProfile?.full_name,
            email: user?.email
          }} 
          isAuthenticated={isAuthenticated} 
        />
        <div className="flex-grow flex items-center justify-center p-4 md:p-8 pt-28 md:pt-36">
          <div className="w-full max-w-6xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
              {/* Left Column - Registration Form */}
              <div className="bg-surface-dark/50 backdrop-blur-xl border border-border rounded-2xl shadow-2xl p-8">
                <RegistrationForm />
              </div>
              
              {/* Right Column - Student Benefits */}
              <div className="lg:sticky lg:top-8">
                <BenefitsSection />
              </div>
            </div>
          </div>
        </div>
        <TrustSignals />
      </div>
    </>
  );
};

export default Registration;